<template>
  <div class="white">
    <h1>
      <span style="font-weight: 400;">Forbidden words - how to play?</span>
    </h1>
    <p>
      <span style="font-weight: 400;">Forbidden words is a social game for a minimum of two teams.</span>
    </p>
    <ol>
      <li style="font-weight: 400;">
        <span
          style="font-weight: 400;"
        >All players should be divided into teams (minimum 2, maximum 4)</span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;">Each team has to come up with a name for themselves.</span>
      </li>
      <li style="font-weight: 400;">
        <span
          style="font-weight: 400;"
        >After launching the application, enter the teams and determine the parameters of the game. Basic settings are recommended for beginners.</span>
      </li>
      <li style="font-weight: 400;">
        <span
          style="font-weight: 400;"
        >The game is divided into rounds in which all teams present words.</span>
      </li>
      <li style="font-weight: 400;">
        <span
          style="font-weight: 400;"
        >In each round each team chooses one person from their team called "PRESENTER" which will present the WORD. Player from another team called "ARBITER" supports the application and checks whether the presenting player has not used the PROHIBITED WORD.</span>
      </li>
      <li style="font-weight: 400;">
        <span
          style="font-weight: 400;"
        >The task of ARBITER is to award points in case the team of the PRESENTER guesses the word, omit the words at the request of the PRESENTER or punish the team PRESENTER in the event that the PRESENTER will use the forbidden word or break the rules.</span>
      </li>
      <li style="font-weight: 400;">
        <span
          style="font-weight: 400;"
        >Each of the teams has a default of 90 seconds to get the most points for guessing the largest possible number of words presented by the PRESENTER.</span>
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;">The PRESENTER during his round can:</span>
      </li>
      <ol>
        <li style="font-weight: 400;">
          <span style="font-weight: 400;">use gestures</span>
        </li>
        <li style="font-weight: 400;">
          <span
            style="font-weight: 400;"
          >describe the WORD without using the WORD or forbidden words, including:</span>
        </li>
        <ol>
          <li style="font-weight: 400;">
            <span style="font-weight: 400;">their foreign language counterparts</span>
          </li>
          <li style="font-weight: 400;">
            <span style="font-weight: 400;">their varieties</span>
          </li>
          <li style="font-weight: 400;">
            <span style="font-weight: 400;">joints</span>
          </li>
          <li style="font-weight: 400;">
            <span style="font-weight: 400;">individual letters of the alphabet or other code</span>
          </li>
        </ol>
      </ol>
      <li style="font-weight: 400;">
        <span
          style="font-weight: 400;"
        >The game is played until the pre-determined number of points is reached, default 20.</span>
      </li>
    </ol>
    <p>
      <span style="font-weight: 400;">Have fun!</span>
    </p>
    <div class="button">
      <router-link to="/" class="back">
        <button>Back</button>
      </router-link>
    </div>
    <br>
    <footer>
      <a href="https://grupa.itdesk.eu">2018 &copy; Progressive Web Applications coded by itDesk.eu</a>
    </footer>
  </div>
</template>


<script>
export default {};
</script>


<style>
.white {
  color: #fff;
}
.back {
  display: grid;
  justify-content: center;
}
.button > li {
  list-style: none;
}
footer {
  color: white;
  font-size: 1.8vh;
  position: absolute;
  bottom: 0;
  width: 99vw;
  height: 3vh;
  text-align: center;
}
footer > a {
  color: #fff;
  text-decoration: none;
}
button{
    
}
</style>
